import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import { LoginModel } from "@/views/authenticate/authenticate.types";
import { ClientDDL, ClientInfo } from "@/views/base/base.types";
import { 
  SowsAssessment, 
  DoseTime,
  WatchWorn,
  WatchCharging,
  ParticipantPayment,
  ResearchRewards,
  PaymentStatus,
  AppointmentStatus,
  AlertZone,
  BiometricCollectionCount,
  AssessmentSummary
} from "@/views/sidebar/research-data/research-data.types";
import { ResearchParticipant } from "@/views/research/research.types"
import moment from "moment";

@Component({
  computed: {
    ...mapState("ResearchData", [
      "sowsAssessments",
      "doseTimes",
      "watchWorn",
      "watchCharging",
      "biometricRecordCount",
      "participantPayment",
      "researchRewards",
      "paymentStatus",
      "appointmentStatus",
      "sowsAlertZones",
      "assessmentSummary"
    ]),
    ...mapFields("ResearchData", [
      "researchParticipant",
      "pickDate"
    ]),
    ...mapState("Authenticate", [
      "user"
    ]),
    ...mapState("Base", [
      "selectedClientDDL",
      "clientInfo"
    ])
  }
})
export default class ResearchDataMixin extends Vue {
  sowsAlertZones!: AlertZone[];
  clientInfo!: ClientInfo[];
  sowsAssessments!: SowsAssessment[];
  doseTimes!: DoseTime[];
  watchWorn!: WatchWorn;
  watchCharging!: WatchCharging;
  participantPayment!: ParticipantPayment;
  researchRewards!: ResearchRewards[];
  assessmentSummary!: AssessmentSummary[];
  paymentStatus!: PaymentStatus;
  appointmentStatus!: AppointmentStatus;
  selectedClientDDL!: ClientDDL;
  user!: LoginModel;
  biometricRecordCount!: BiometricCollectionCount;
  researchParticipant!: ResearchParticipant;
  pickDate!: Date;

  get selectedClient() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    ) ?? new ClientInfo;
  }

  get selectedResearchDuration() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    )?.researchDuration ?? 0;
  }

  timeConfig = {
    format: 'h:mm A',
    showClear: true,
    showClose: true,
    stepping: 1,
    inline: true,
    toolbarPlacement: 'bottom',
    icons: {
      time: 'fa fa-clock',
      up: 'fa fa-arrow-up',
      down: 'fa fa-arrow-down',
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      clear: 'fa fa-trash',
      close: 'fa fa-times'
    }
  };

  displayDate(pickDate: string) {
    return moment(pickDate).format("MMMM Do, YYYY");
  }

  isLeftDisabled(date: string, pickDate: string): boolean {
    const researchDay1 = moment(date, 'YYYY-MM-DD');
    const nextDay = researchDay1.clone();
    return moment(pickDate).isSame(nextDay, 'day');
  }

  isRightDisabled(date: string, pickDate: string): boolean {
    const researchDay1 = new Date(date);
    const limitDate = new Date(researchDay1);
    limitDate.setDate(limitDate.getDate() + this.selectedResearchDuration);
    return new Date(pickDate).toDateString() === limitDate.toDateString();
  }
}